import { styled } from '@mui/material/styles';

/**
 * Heading component for the cancellation process - temporary component (pre design system)
 * */
const Heading = styled('h1')({
	fontSize: '24px',
	lineHeight: '32px',
	fontWeight: 600,
	marginTop: '0',
	marginBottom: '40px',
});
export default Heading;
